import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, ownerOnly = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-loading">
                <div className="overline">Loading session…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (ownerOnly && user.role !== "owner") return <Navigate to="/dashboard" replace />;
    return children;
}
